__webpack_require__.p = "https://static.spqr.app/a38affd3c0ef0752be05b1d03e7010d015129db5/_next/";